<template>
    <dx-data-grid
        ref="dataGridRef"
        :allow-column-reordering="true"
        :column-chooser="{ enabled: true, mode: 'select' }"
        :column-min-width="50"
        :columns="columns"
        :data-source="dataSource"
        :filter-panel="{ visible: true }"
        :filter-row="{ visible: true }"
        :header-filter="{ visible: true }"
        :height="50"
        :hover-state-enabled="true"
        :remote-operations="{ filtering: true, paging: true, sorting: true, summary: true }"
        :repaint-changes-only="true"
        :row-alternation-enabled="true"
        :show-borders="true"
        :show-column-lines="true"
        :width="'100%'"
        :word-wrap-enabled="true"
        style="flex-grow: 1"
        value-expr="id"
        @toolbar-preparing="onToolbarPreparing($event)"
        @on-cell-prepared="onCellPrepared($event)"
        @content-ready="onContentReady($event)"
    >
        <dx-paging :enabled="true" :page-size="40" />
        <dx-load-panel :enabled="true" />
        <dx-scrolling mode="virtual" />
        <dx-sorting mode="single" />
        <dx-export :allow-export-selected-data="true" :enabled="true" :formats="['pdf', 'excel']" />
        <dx-editing
            :allow-deleting="true"
            :allow-updating="true"
            :refresh-mode="'full'"
            mode="batch"
        />
    </dx-data-grid>
    <footer-grid :show-selected-counter="false" :totalCount="totalCount" class="px-2"></footer-grid>
</template>

<script>
export default {
    name: 'mped-spr-fed-subject-view',
};
</script>

<script setup>
import { ref } from 'vue';
import {
    DxDataGrid,
    DxEditing,
    DxExport,
    DxLoadPanel,
    DxPaging,
    DxScrolling,
    DxSorting,
} from 'devextreme-vue/data-grid';

import { fedSubjectsColumns } from '@/views/mped/views/vbSprFedSubject/meta';
import { addNewRowData, getAiDataSource } from '@/components/utils/ai-data-source-generator';
import { checkHasEditData, getAiToolbar, undoEditData } from '@/components/utils/ai-toolbar-generator';
import { getSprFedSubject, setSprFedSubject } from '@/views/mped/views/vbSprFedSubject/api-meta';
import FooterGrid from '@/components/grid-card-component/footer-grid.vue';

const dataGridRef = ref();
const totalCount = ref(0);
let toolbarButtons = {};

const dataSource = getAiDataSource(
    {
        dataFn: getSprFedSubject,
        key: 'kod_spr_subj',
        remoteOperation: true,
        insertFn: (values) => {
            return setSprFedSubject({ insertDataArgs: [values] });
        },
        updateFn: (kod_spr_subj, values) => {
            return setSprFedSubject({ updateDataArgs: [{ kod_spr_subj, ...values }] });
        },
        removeFn: (kod_spr_subj) => {
            return setSprFedSubject({ deleteDataArgs: [{ kod_spr_subj }] });
        },
        onLoadedFn: (data) => {
            totalCount.value = data.totalCount;
        },
        defaultDescSort: false,
    },
);

const columns = fedSubjectsColumns();

const onToolbarPreparing = (e) => {
    toolbarButtons = getAiToolbar(e, {
        refresh: {
            event: reloadData,
        },
        add: {
            event: addData,
        },
        save: {
            event: () => {
                dataGridRef.value.instance.saveEditData();
            },
        },
        undo: {
            event: (e) => {
                undoEditData(dataGridRef.value.instance);
            },
        },
    });
};

const reloadData = () => {
    dataSource.reload();
};

const addData = (e) => {
    const allData = dataGridRef.value.instance.getDataSource().items();
    const maxId = allData.reduce((max, item) =>
        Math.max(max, item.kod_spr_subj || 0), 0);
    const newData = {
        ...e,
        kod_spr_subj: maxId + 1,
    };

    addNewRowData({
        dxInstance: dataGridRef.value.instance,
        sourceData: {
            kod_spr_subj: newData.kod_spr_subj,
            ...newData,
        },
        fields: ['kod_spr_subj', 'kod_subj', 'subject_name'],
    });
    dataSource.reload();
};

const onContentReady = () => {
    checkHasEditData(dataGridRef.value.instance, toolbarButtons);
};

const onCellPrepared = (e) => {
    if (e.rowType !== 'data' || e.columnIndex != 0) {
        return;
    }
};
</script>

<style scoped>

</style>
